import { useState } from 'react';
import { faExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Box,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Grid,
  Stack,
} from '@mui/material';
import CustomSlider from '../CustomSlider';
import ModalComponent from '../../../../components/ModalComponent';
import api from '../../../../services/api';
import { useUserContext } from '../../../../contexts/UserContext';

function Withdrawal() {
  // variables
  const { logoutUser } = useUserContext();
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [resetSlider, setResetSlider] = useState(false);
  const [hasVerified, setHasVerified] = useState(false);
  const [isCertainThatWantsToWithdraw, setIsCertainThatWantsToWithdraw] = useState(false);

  // functions
  const handleCancelSubscription = async () => {
    setIsLoading(true);
    await api.post('/v1/plans/withdrawal')
      .then(() => {
        logoutUser();
      }).catch((err) => {
        setErrorMessage(err.message);
      }).finally(() => {
        setIsLoading(false);
      });
  };

  const handleCloseModal = () => {
    setResetSlider(true);
    setIsCertainThatWantsToWithdraw(false);
  };

  const handleChangeHasVerified = () => {
    setHasVerified(!hasVerified);
  };

  // render conditions
  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="90vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box className="py-5 container-fluid">
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
      >
        <Grid item sx={{ marginTop: 2 }}>
          <h1>退会の手続き</h1>
        </Grid>
        <Grid item sx={{ marginBottom: 2, fontSize: '12px' }}>
          会員の退会手続きを行います。注意事項の記載内容をご確認ください。
        </Grid>
        <Grid item className="text-start">
          <Box
            sx={{
              border: '1px solid rgb(220, 53, 69)',
              padding: '1rem',
            }}
          >
            <h4 className="text-bold text-danger p-2">
              <FontAwesomeIcon className="px-2" icon={faExclamation} />
              退会手続きのご注意
            </h4>
            <p>
              ・退会の取り消しはできません。
              <br />
              ・退会したアカウントは元に戻すことはできません。
              <br />
              ・退会手続きをすると、全てのサービスがご利用できなくなります。
              <br />
              ・退会手後は、作成したページはすべて削除されます。
            </p>
          </Box>
        </Grid>
        <Grid
          item
          sx={{
            justifyContent: 'start',
            marginTop: '1rem',
          }}
        >
          <FormControlLabel
            control={(
              <Checkbox
                checked={hasVerified}
                onChange={handleChangeHasVerified}
              />
            )}
            label="確認しました"
          />
        </Grid>
        <Grid item>
          <Stack spacing={2} direction="row" sx={{ m: 3 }} alignItems="center">
            <CustomSlider
              disabled={!hasVerified}
              resetSlider={resetSlider}
              setIsCertainThatWantsToWithdraw={setIsCertainThatWantsToWithdraw}
              setResetSlider={setResetSlider}
            />
          </Stack>
        </Grid>
      </Grid>

      <ModalComponent
        title="退会確認"
        show={isCertainThatWantsToWithdraw}
        confirmButtonText="退会する"
        onConfirm={handleCancelSubscription}
        closeModal={handleCloseModal}
        errorMessage={errorMessage}
      >
        <span>退会してもよろしいですか？</span>
      </ModalComponent>
    </Box>
  );
}

export default Withdrawal;
